import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as token from "@universityofmaryland/web-token-library";
import { createMediaQuery } from "@universityofmaryland/web-utilities-library/styles";
import "@universityofmaryland/web-styles-library/element";
import "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-styles-library/animation";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/media";
import "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-icons-library/controls";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import "@universityofmaryland/web-icons-library/brand";
import "@universityofmaryland/web-icons-library/arrows";
import "@universityofmaryland/web-utilities-library/performance";
import "../../atomic/animations/brand/chevron-scroll.js";
import "../../atomic/animations/brand/card-stack.js";
import "@universityofmaryland/web-styles-library";
import "@universityofmaryland/web-utilities-library/accessibility";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "@universityofmaryland/web-utilities-library/theme";
import "../../atomic/layout/block/stacked.js";
import "../../atomic/layout/overlay/modal.js";
import { image, information } from "../../atomic/layout/person/columns.js";
import "@universityofmaryland/web-icons-library/social";
import "../../atomic/text-lockup/date.js";
import "../../atomic/text-lockup/small.js";
const smallBreakpoint = token.media.breakpointValues.small.max;
const mediumBreakpointStart = token.media.breakpointValues.medium.min;
const mediumBreakpoint = token.media.breakpointValues.large.min;
const CreatePersonListElement = ({
  actions,
  address,
  slotOne,
  email,
  image: image$1,
  isThemeDark,
  slotTwo,
  linkedin,
  name,
  phone,
  slotThreeItalic,
  slotFour
}) => {
  const builder = new ElementBuilder().withClassName("person-list-container").withStyles({
    element: {
      overflow: "hidden",
      display: "flex",
      ...createMediaQuery("max-width", smallBreakpoint, {
        flexDirection: "column"
      })
    }
  });
  if (image$1) {
    builder.withChild(
      image({
        customStyles: {
          ...createMediaQuery("min-width", mediumBreakpointStart, {
            display: "block",
            width: "160px",
            minWidth: "160px",
            paddingRight: `${token.spacing.md}`,
            alignSelf: "flex-start"
          }),
          ...createMediaQuery("min-width", mediumBreakpoint, {
            width: "208px",
            minWidth: "208px"
          })
        },
        image: image$1,
        isThemeDark
      })
    );
  }
  if (name) {
    builder.withChild(
      information({
        actions,
        address,
        slotTwo,
        customStyles: {},
        email,
        isThemeDark,
        slotOne,
        linkedin,
        name,
        phone,
        slotThreeItalic,
        slotFour
      })
    );
  }
  return builder.build();
};
const createCompositePersonList = CreatePersonListElement;
export {
  createCompositePersonList
};
//# sourceMappingURL=list.js.map
